import { render, staticRenderFns } from "./ForebyggingStandardPage.vue?vue&type=template&id=2d6b0563"
import script from "./ForebyggingStandardPage.vue?vue&type=script&lang=js"
export * from "./ForebyggingStandardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports